const DefaultAdaptor = {
  back: () => window.history?.back?.(),
  deviceBack: () => window.history?.back?.(),
  close: () => window.close?.(),
  topBack: () => window.history?.back?.(),
};

const BLNativeBridgeInit = {
  // Available functions:
  // See https://bukalapak.atlassian.net/wiki/spaces/MOBS/pages/802291983/Javascript+Bridge
  bridgeFunctions: [
    'back',
    'close',
    'setResult',
    'setTopBar',
    'setDeviceBar',
    'topBack',
    'deviceBack',
    'setContentBehavior',
    'registerInvoiceTrackerConversion',
    'openPinLandingScreen',
  ],
  init() {
    try {
      const warnDecorator = wrapped => (...args) => {
        // eslint-disable-next-line no-console
        console.warn(
          '[Warning] Use BLNativeBridge for more powerful bridging function. Just add more functions there if needed.',
        );
        const result = wrapped.apply(this, args);
        return result;
      };
      if (window.android) {
        Object.keys(window.android).forEach(key => {
          window.android[key] = warnDecorator(window.android[key]);
        });
      }
      if (window.blandroid) {
        Object.keys(window.blandroid).forEach(key => {
          window.blandroid[key] = warnDecorator(window.blandroid[key]);
        });
      }
      if (window.webkit?.messageHandlers) {
        Object.keys(window.webkit.messageHandlers).forEach(key => {
          window.webkit.messageHandlers[key].postMessage = warnDecorator(
            window.webkit.messageHandlers[key].postMessage,
          );
        });
      }
      this.bridgeFunctions.forEach(func => {
        this[func] = (...args) => this.exec(func, ...args);
      });
    } catch {
      // do nothing
    }
  },
  exec(func, ...args) {
    try {
      if (window.android?.[func]) {
        window.android[func](...args);
      } else if (window.blandroid?.[func]) {
        window.blandroid[func](...args);
      } else if (window.webkit?.messageHandlers?.[func]) {
        const data = args.length > 0 ? args : [''];
        window.webkit.messageHandlers[func].postMessage(...data);
      } else if (DefaultAdaptor[func]) {
        DefaultAdaptor[func](...args);
      }
    } catch {
      // do nothing
    }
  },
  isAvailable(func) {
    if (func) {
      return (
        !!window.android?.[func] ||
        !!window.blandroid?.[func] ||
        !!window.webkit?.messageHandlers?.[func]
      );
    }
    return (
      !!window.android || !!window.blandroid || !!window.webkit?.messageHandlers
    );
  },
};

const BLNativeBridge = {
  ...BLNativeBridgeInit,
  install(Vue) {
    BLNativeBridgeInit.init();
    Vue.prototype.$nativeBridge = BLNativeBridgeInit;
    delete this.install;
  },
};

export default BLNativeBridge;
